import _DTO from "./_DTO";

export default class TerminalBlockPreferencesDTO extends _DTO {
  constructor(preferences) {
    super();
    this.cover = preferences.cover;
    this.electricalConnection = preferences.electricalConnection;
  }
}
